
import { Vue, Component } from "vue-property-decorator";
import { documentStore } from "@/store/store";

import {
  copyElements,
  getDataFromClipboard,
  pasteElement
} from "@/lib/copy-paste/copy-paste";
import { pasteElements } from "@/lib/design-library/design-library";
import IconButton from "@/components/UI/IconButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { configStore } from "@/store/store";

@Component({
  components: {
    IconButton,
    Dropdown
  }
})
export default class StructurePanelDropdownMenu extends Vue {
  copy() {
    copyElements(documentStore.document.tree.root.children.map(n => n.id));
  }

  get builderMode() {
    return configStore.builderMode;
  }

  async paste() {
    const elementOrElementsToPaste = (await getDataFromClipboard())?.element;
    if (Array.isArray(elementOrElementsToPaste)) {
      pasteElements(elementOrElementsToPaste, "pasting");
    } else if (elementOrElementsToPaste) {
      pasteElement(null, elementOrElementsToPaste);
    } else {
      alert("nothing to paste");
    }
  }
}
